import { render } from "./AdminNotificaciones.vue?vue&type=template&id=15da2d9e&scoped=true"
import script from "./AdminNotificaciones.vue?vue&type=script&lang=js"
export * from "./AdminNotificaciones.vue?vue&type=script&lang=js"

import "./AdminNotificaciones.vue?vue&type=style&index=0&id=15da2d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15da2d9e"]])

export default __exports__